import { type FC, memo, type ReactNode, useCallback, useState } from "react";
import BulkAddToCartDialog from "~/features/bulkAddToCart/components/BulkAddToCartDialog";
import { sendPopupOpen } from "~/app/analytics/ga/bulkUpload";
import { useSessionState } from "~/app/providers/SessionProvider";

interface RenderProps {
  openPopup: () => void;
  closePopup: () => void;
  disabled: boolean;
}

interface BulkATCPopupContextProps {
  children: (props: RenderProps) => ReactNode;
}

const BulkATCPopupContext: FC<BulkATCPopupContextProps> = ({ children }) => {
  const [open, setOpen] = useState(false);
  const { cartActionsDisabled } = useSessionState();

  const openPopup = useCallback(() => {
    if (cartActionsDisabled) {
      return;
    }
    setOpen(true);
    sendPopupOpen();
  }, [cartActionsDisabled]);
  const closePopup = useCallback(() => setOpen(false), []);

  const props = { openPopup, closePopup, disabled: cartActionsDisabled };

  return (
    <>
      {children(props)}
      {open && !cartActionsDisabled && <BulkAddToCartDialog onClose={closePopup} />}
    </>
  );
};
export default memo(BulkATCPopupContext);
